import { useLazyQuery } from '@apollo/client';
import { lookupVisitorWatchlist } from 'graphql-queries';
import { LookupVisitorInput, WatchlistMatch } from 'graphql-query-contracts';

export const useVisitorWatchlistLookup = () => {
  const [lookupVisitor] = useLazyQuery(lookupVisitorWatchlist, {
    fetchPolicy: 'network-only',
  });

  const performLookup = async (
    organizationId: string,
    visitor: LookupVisitorInput
  ): Promise<WatchlistMatch[]> => {
    const result = await lookupVisitor({
      variables: {
        organizationId,
        lookupVisitor: visitor,
      },
    });

    const matches = result?.data?.lookupVisitorWatchlist?.matches;

    if (!matches) {
      return [];
    }

    return matches;
  };

  return {
    performLookup,
  };
};
